import type { WiwState } from '@/store';

export const getMessages = (state: WiwState) => {
  return state.workchat.messages;
};
